/**
* Blog Roll JS
* -----------------------------------------------------------------------------
*
* All the JS for the Blog Roll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'blog-roll',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.blog-roll' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--blog-roll' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '24px',
          autoWidth: false,
          perPage: 3,
          perMove: 1,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
              gap: '20px',
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'blog-roll', COMPONENT );
} )( app );
